import {
  SET_MODALVISIBLE,
  CLEANUP,
  SET_FUNDID,
  SET_MUTUALCREDIT_FUNDID,
  SET_VIRTUALACCOUNTNAME,
  SET_VIRTUALACCOUNTNUMBER,
  SET_ORIGINATOR,
  SET_ORIGINATORID,
  SET_SETTLEMENTCURRENCY,
  SET_SETTLEMENTAMOUNT,
  SET_SETTLEMENTAMOUNT_MINUS_FEE,
  SET_CLIENTFEEAMOUNT,
  SET_VALIDATESTATUS,
  GET_ORIGINATOR_REQUEST,
  GET_ORIGINATOR_SUCCESS,
  GET_ORIGINATOR_FAILURE,
  GET_BANKTRANSACTION_LINKS_REQUEST,
  GET_BANKTRANSACTION_LINKS_SUCCESS,
  GET_BANKTRANSACTION_LINKS_FAILURE,
} from "./addVaSettleType";

import { getOriginatorById, fetchBankTransactionLinks } from "../../api/api";

export const cleanup = () => {
  return {
    type: CLEANUP,
  };
};

export const setModalVisible = (modalVisible) => {
  return {
    type: SET_MODALVISIBLE,
    modalVisible: modalVisible,
  };
};

export const setFundId = (fundId) => {
  return {
    type: SET_FUNDID,
    fundId: fundId,
  };
};

export const setMutualCreditFundId = (mutualCreditFundId) => {
  return {
    type: SET_MUTUALCREDIT_FUNDID,
    mutualCreditFundId: mutualCreditFundId,
  };
};

export const setVirtualAccountName = (virtualAccountName) => {
  return {
    type: SET_VIRTUALACCOUNTNAME,
    virtualAccountName: virtualAccountName,
  };
};

export const setVirtualAccountNumber = (virtualAccountNumber) => {
  return {
    type: SET_VIRTUALACCOUNTNUMBER,
    virtualAccountNumber: virtualAccountNumber,
  };
};

export const setOriginatorId = (originatorId) => {
  return {
    type: SET_ORIGINATORID,
    originatorId: originatorId,
  };
};

export const setOriginator = (originator) => {
  return {
    type: SET_ORIGINATOR,
    originator: originator,
  };
};

export const setSettlementCurrency = (settlementCurrency) => {
  return {
    type: SET_SETTLEMENTCURRENCY,
    settlementCurrency: settlementCurrency,
  };
};

export const setSettlementAmount = (settlementAmount) => {
  return {
    type: SET_SETTLEMENTAMOUNT,
    settlementAmount: settlementAmount,
  };
};

export const setSettlementAmountMinusFee = (settlementAmountMinusFee) => {
  return {
    type: SET_SETTLEMENTAMOUNT_MINUS_FEE,
    settlementAmountMinusFee: settlementAmountMinusFee,
  };
};

export const setClientFeeAmount = (clientFeeAmount) => {
  return {
    type: SET_CLIENTFEEAMOUNT,
    clientFeeAmount: clientFeeAmount,
  };
};

export const setValidateStatus = (validateStatus) => {
  return {
    type: SET_VALIDATESTATUS,
    validateStatus: validateStatus,
  };
};

const getOriginatorRequest = () => {
  return {
    type: GET_ORIGINATOR_REQUEST,
  };
};

const getOriginatorSuccess = (payload) => {
  return {
    type: GET_ORIGINATOR_SUCCESS,
    payload: payload,
  };
};

const getOriginatorFailure = (error) => {
  return {
    type: GET_ORIGINATOR_FAILURE,
    payload: error,
  };
};

export const getOriginator = (originatorId) => {
  return async (dispatch) => {
    if (originatorId) {
      dispatch(getOriginatorRequest());
      try {
        var response = await getOriginatorById(originatorId);

        // return data
        dispatch(getOriginatorSuccess(response));
      } catch (error) {
        dispatch(getOriginatorFailure(error.message));
      }
    }
  };
};

const getBankTransactionLinksRequest = () => {
  return {
    type: GET_BANKTRANSACTION_LINKS_REQUEST,
  };
};

const getBankTransactionLinksSuccess = (payload) => {
  return {
    type: GET_BANKTRANSACTION_LINKS_SUCCESS,
    payload: payload,
  };
};

const getBankTransactionLinksFailure = (error) => {
  return {
    type: GET_BANKTRANSACTION_LINKS_FAILURE,
    payload: error,
  };
};

export const getBankTransactionLinks = (bankTransactionId) => {
  return async (dispatch) => {
    if (bankTransactionId) {
      dispatch(getBankTransactionLinksRequest());
      try {
        var response = await fetchBankTransactionLinks(bankTransactionId);
        // return data
        dispatch(getBankTransactionLinksSuccess(response));
      } catch (error) {
        dispatch(getBankTransactionLinksFailure(error.message));
      }
    }
  };
};
